import { useTranslation } from 'react-i18next';

import type { QuotationForClient } from '~/api/quotations/types';
import type { UserLanguage } from '~/api/user/types';

import { Card } from '~/components';
import { useIntl } from '~/hooks/useIntl';
import { clsx } from '~/styles/utils';

import {
  grandTotalStyle,
  semiboldStyle,
  totalsRowsStyle,
  totalsRowStyle,
  totalsStyle,
  totalsValueStyle,
  totalsWrapperStyle,
} from './QuotationForClient.css';

type Props = {
  calculationData: QuotationForClient['quotation']['calculationData'];
  language: UserLanguage;
};

export const QuotationForClientTotals = ({ calculationData, language }: Props) => {
  const { formatCurrency } = useIntl(language);
  const { t } = useTranslation(['lines']);

  return (
    <div className={totalsWrapperStyle}>
      <div className={totalsStyle}>
        <div className={totalsRowsStyle}>
          <div className={clsx(totalsRowStyle, semiboldStyle)}>
            <span>{t('lines:subtotal')}</span>
            <span className={totalsValueStyle}>{formatCurrency(calculationData.coExclVat)}</span>
          </div>

          <div className={totalsRowStyle}>
            <span>{t('lines:totalVat')}</span>
            <span className={totalsValueStyle}>{formatCurrency(calculationData.coVat)}</span>
          </div>
        </div>

        <Card.Root size="small" variant="primary-brand">
          <div className={clsx(totalsRowStyle, grandTotalStyle)}>
            <span>{t('lines:total')}</span>
            <span className={totalsValueStyle}>{formatCurrency(calculationData.coInclVat)}</span>
          </div>
        </Card.Root>
      </div>
    </div>
  );
};
